import React from "react";

import { Box, Input, Span } from "@chakra-ui/react";
import { Maybe } from "utils/general/maybe";

import { Paragraph2 } from "ui/typography";

import { switchInputCss, switchSliderCss } from "./styles";
import { IToggleSwitchProps } from "./types";

export const ToggleSwitch = (props: IToggleSwitchProps) => {
  const {
    isChecked,
    handleToggleSwitch,
    toggleSwitchWrapperClassName,
    label,
    labelClassName,
    customStyles,
  } = props;

  const handleToggle = (evt: React.ChangeEvent<HTMLInputElement>) => {
    const { checked } = evt.target;
    handleToggleSwitch(checked);
  };

  return (
    <Box
      className={`inline-flex items-center gap-2 ${toggleSwitchWrapperClassName}`}
    >
      <label
        className={`relative inline-block ${customStyles ? `${customStyles?.customInputWrapperClassName || ""}` : "w-[36px] h-[20px]"}`}
      >
        <Input
          type="checkbox"
          checked={isChecked}
          onChange={handleToggle}
          css={
            customStyles
              ? customStyles?.customSwitchInputCss || {}
              : switchInputCss
          }
        />
        <Span
          css={
            customStyles
              ? customStyles?.customSwitchSliderCss || {}
              : switchSliderCss
          }
        />
      </label>
      <Maybe condition={Boolean(label)}>
        <Paragraph2
          lineHeight="22px"
          textColor="#4A5564"
          className={labelClassName}
        >
          {label}
        </Paragraph2>
      </Maybe>
    </Box>
  );
};
